<template>
  <div class="switchingAssetTypesCom">
    <el-radio-group v-model="active" size="mini">
      <el-radio-button label="系统"></el-radio-button>
      <el-radio-button label="部门"></el-radio-button>
      <el-radio-button label="区域"></el-radio-button>
      <el-radio-button label="能源结构"></el-radio-button>
    </el-radio-group>
    <div class="charts">
      <PublicEcharts
        :id="'types' + item.id"
        :chartsData="item.charts"
        :type="'themeTransverseBar'"
      />
    </div>
  </div>
</template>

<script>
import PublicEcharts from "@/components/PublicEcharts.vue";
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    PublicEcharts,
  },
  data() {
    return {
      active: "系统",
    };
  },
};
</script>

<style lang="scss" scoped>
.switchingAssetTypesCom {
  width: 100%;
  height: 100%;
  .tabs {
  }
  .charts {
    width: 100%;
    height: 90%;
  }
}
</style>
